// extracted by mini-css-extract-plugin
export default {"accountItem":"style_accountItem__Tq7u7","avatar":"style_avatar__OI0y8"};